/**
 * For when we are dealing with strings and can't/won't convert to a URL object,
 * eg: when using patterns - `https://example.com/test/:varValue1?parent1=:varValue2&parent2=:varValue3`)
 */
export const urlOriginGet = (url: string) => {
  const match = url.match(/^https?:\/\/[^/]+/);
  return (match && match[0]) || '';
};
